import { Tabs, TabsProps } from 'antd';
import { FormattedMessage } from 'react-intl';
import LayoutComponent from '../../components/LayoutComponent/LayoutComponent';
import TrapImageInsectsVariationSettings from './TrapImageInsectsVariationSettings/TrapImageInsectsVariationSettings';

const SettingsPage: React.FC = () => {
    /***HOOKS***/

    /***METHODS***/

    /***VISUAL***/

    const items: TabsProps['items'] = [
        {
            key: 'insectsVariation',
            label: <FormattedMessage id="settings.insectsVariation" />,
            children: <TrapImageInsectsVariationSettings />,
            forceRender: true
        }
    ];

    return (
        <LayoutComponent
            title={<FormattedMessage id="settings.title" />}
            menu="settings"
            path={[{ path: '/settings', name: <FormattedMessage id="settings.title" /> }]}
        >
            <Tabs defaultActiveKey="insectsVariation" items={items} />
        </LayoutComponent>
    );
};
export default SettingsPage;
